import { Job } from '@/types/job';

export const validWaysOfContact = (job: Job) =>
  job.connekt ? [] : job.waysOfContact.filter((wayOfContact) => ![`SEND_RESUME`].includes(wayOfContact));
